import { currencyCodes } from "./maps";

export const isLocalizedCode = (
  data: string,
): data is keyof typeof currencyCodes => {
  return Object.keys(currencyCodes).includes(data);
};
